import React from 'react';
import { MapPin, Star } from 'lucide-react';
export function VenueHighlight() {
  return <section id="venue" className="py-24 bg-[#2F1B10] text-white relative" data-id="element-238">
      <div className="container mx-auto px-4 md:px-6" data-id="element-239">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-240">
          <div className="order-2 lg:order-1" data-id="element-241">
            <div className="relative" data-id="element-242">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-[#D2691E] opacity-50" data-id="element-243"></div>
              <img src="https://images.unsplash.com/photo-1558030006-450675393462?w=1000&q=80" alt="Texas BBQ Brisket" className="rounded-lg shadow-2xl w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-244" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-[#D2691E] opacity-50" data-id="element-245"></div>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-246">
              <img src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80" alt="BBQ Restaurant" className="rounded-lg shadow-lg h-48 w-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-247" />
              <div className="bg-[#8B4513] rounded-lg p-6 flex flex-col justify-center items-center text-center border border-[#D2691E]" data-id="element-248">
                <Star className="text-[#F4A460] mb-2" size={32} fill="#F4A460" data-id="element-249" />
                <span className="text-3xl font-bold font-serif text-white" data-id="element-250">
                  #1
                </span>
                <span className="text-[#F4A460] font-medium" data-id="element-251">
                  BBQ in America
                </span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-252">
            <div className="inline-block bg-[#D2691E] text-white px-3 py-1 rounded-full text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-253">
              Venue Highlight
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 font-serif text-[#FFF8DC]" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-254">
              Franklin Barbecue <br data-id="element-255" />
              <span className="text-[#D2691E]" data-id="element-256">Private Dinner</span>
            </h2>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-257">
              We've secured a private takeover of the legendary Franklin
              Barbecue for our evening reception. Experience the brisket that
              changed the BBQ world forever—without the famous 4-hour line.
            </p>

            <ul className="space-y-6" data-id="element-258">
              {['Private restaurant takeover - no line required', 'Full menu of brisket, ribs, and sides', 'Local craft beers and drinks included', 'Potential fireside chat with Aaron & Stacy Franklin'].map((item, index) => <li key={index} className="flex items-start" data-id="element-259">
                  <span className="bg-[#D2691E] rounded-full p-1 mr-4 mt-1" data-id="element-260">
                    <Star size={12} className="text-white" fill="white" data-id="element-261" />
                  </span>
                  <span className="text-[#F4A460] text-lg" data-id="element-262">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10 flex items-center gap-2 text-gray-400" data-id="element-263">
              <MapPin size={20} className="text-[#D2691E]" data-id="element-264" />
              <span data-id="element-265">900 E 11th St, Austin, TX 78702</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}